import React, { Component } from 'react';
import { Button,Form,Input,Row,Col,message,Select,Tabs,Table} from 'antd'
import updateCPWallet from '../../mutation/updateCPWallet'
import getUserWalletTransactions from '../../queries/getUserWalletTransactions'
import { withApollo } from 'react-apollo';
import moment from 'moment'
import {returnSymbol} from '../../utils/returnSymbol'

const FormItem = Form.Item
const { Option } = Select;
const { TabPane } = Tabs;
const { TextArea } = Input;
const mode = [
    {internalName: 'CASH',displayName: 'CASH',paymentState: 'PAID_OFFLINE'},
    {internalName: 'UPI',displayName: 'UPI',paymentState: 'PAID_ONLINE'},
    {internalName: 'DEBIT_CARD',displayName: 'DEBIT CARD',paymentState: 'PAID_ONLINE'},
    {internalName: 'CREDIT_CARD',displayName: 'CREDIT CARD',paymentState: 'PAID_ONLINE'},
]
class CPrecharge extends Component {
    constructor(props){
        super(props)
        this.state={
            paymentLoading: false,
            transactions: [],
            tableLoading: false
        }
    }
    handleOk=(e)=>{
        // console.log("on ok")  
        e.preventDefault();
          this.props.form.validateFields(["amount","note","paymentMode","transactionType"],(err, values) => {
            // console.log("values",values)
            // return
              if(!err){
                this.setState({
                  paymentLoading: true
                })
        this.props.client.mutate({
          mutation: updateCPWallet,
          variables: {
            siteId: this.props.cpData.siteId,
            userId: this.props.cpData.username,
            amount: parseInt(values.amount*100),
            note: values.note ? values.note : undefined,
            paymentState: values.paymentMode == 'CASH' ? "PAID_OFFLINE" : 'PAID_ONLINE',
            paymentMode: values.paymentMode,
            transactionType: values.transactionType,

          }
      }).then(({ data }) => {
          // console.log("data response", data)
          message.success("Transaction has been submitted successfully.");
          this.setState({
            paymentLoading: false
          })
          if(this.props.handleCancel){
            this.props.handleCancel({userId: this.props.cpData.username,amount: parseInt(values.amount*100),transactionType:  values.transactionType})
          }
      })
    }
    })
      }
      onTabChange=(key)=>{
        if(key == '2'){
            this.setState({
                tableLoading: true
            })
            this.props.client.query({
            query: getUserWalletTransactions,
            variables: {
                userId: this.props.cpData.username,
            },
            fetchPolicy: 'network-only',
        })
            .then(({ data }) => {
                console.log("data",data)
                this.setState({
                    transactions: data.getUserWalletTransactions,
                    tableLoading: false
                })
            })
        }
      }
    render() {
       const { getFieldDecorator } = this.props.form;
        const columns=[
            {
                title: 'Date',
                dataIndex:'createdAt',
                width: '15%',
                render: (data) => {
                    var dateString = moment.unix(data).format("DD/MM/YYYY HH:mm");
                    return (
                        <span>{dateString}</span>
                    )
                }
            },
            {
                title: 'Type',
                dataIndex: 'transactionType',
                width: '10%',
            },
            {
                title: 'Transaction Amount',
                // dataIndex: 'amount',
                width: '15%',
                render:(data)=>{
                    return(
                        <span>{returnSymbol(data.amount/100,data.currency)}</span>
                    )
                }
            },
            {
                title: 'Balance',
                // dataIndex: 'balance',
                width: '10%',
                render:(data)=>{
                    return(
                        <span>{returnSymbol(data.balance/100,data.currency)}</span>
                    )
                }
            },
            {
                title: 'Note',
                dataIndex: 'note',
                width: '20%',
            },
        ]
        return (
            <>
             <Tabs onChange={this.onTabChange} type="card">
                <TabPane tab="TRANSACTIONS" key="1">
                <Form>
                    <Row gutter={24}>
                        <Col span={8}>
                            <FormItem
                                label="Amount"
                            >
                                {getFieldDecorator(`amount`, {
                                //    initialValue: this.state.settingData.companyName,
                                    rules: [{
                                        required: true,
                                        message: "Please enter Amount between 100 To 100000",
                                        // min:3,max:6
                                    },
                                    ,
                                    {
                                      validator: (rule, value, cb) => {
                                          if (value <1) {
                                                  cb('Please enter Amount Grater than 100')
                                          }
                                          cb()
                                      }
                                  }
                                   ]
                                })(
                                  <Input   type= "number" placeholder="Enter Amount"  onChange={this.rAmount}></Input>
                                )}
                            </FormItem>
                            </Col>
                            <Col span={8}>
                            <FormItem label='Payment Mode' >
                                    {getFieldDecorator('paymentMode', {
                                       rules: [{
                                           required: true,
                                           message: "note",
                                       }],
                                   })(
                                       <Select
                                           showSearch
                                           
                                           placeholder="Payment Mode"
                                       >
                                           {mode && mode.length > 0 ? mode.map((c) => {
                                               return (
                                                   <Option key={c.internalName} title={c.displayName} value={c.displayName}>
                                                       <div style={{ whiteSpace: 'normal' }}>{c.displayName}</div>
                                                   </Option>
                                               )
                                           })
                                               : ''}
                                       </Select>
                                   )}
                            </FormItem>
                            </Col>
                            <Col span={8}>
                            <FormItem label='Type' >
                                    {getFieldDecorator('transactionType', {
                                       rules: [{
                                           required: true,
                                           message: "note",
                                       }],
                                   })(
                                       <Select
                                           placeholder="Type"
                                       >
                                          <Option key={'CREDIT'} value={'CREDIT'} >CREDIT</Option>
                                          <Option key={'DEBIT'} value={'DEBIT'} >DEBIT</Option>
                                       </Select>
                                   )}
                            </FormItem>
                            </Col>
                            </Row>
                            <Row gutter={24}>
                            <Col span={24}>
                            <FormItem label='Notes' >
                                    {getFieldDecorator('note', {
                                        rules: [{
                                            required: true,
                                            message: "note",
                                        }],
                                    })(
                                        <TextArea rows={4} placeholder="Note" />
                                    )}
                                </FormItem>
                                </Col>
                                </Row>
                            </Form>
                    <Row>
                      <Button type="primary" onClick={this.handleOk} style={{marginTop: "20px"}} loading={this.state.paymentLoading}>SUBMIT</Button>
                    </Row> 
                    </TabPane>
                    <TabPane tab="HISTORY" key="2">
                    <Table
                        bordered
                        dataSource={ this.state.transactions}
                        columns={ columns}
                        loading={this.state.tableLoading}
                    />
                    </TabPane>
                    </Tabs>
            </>
        );
    }
}
const WCPrecharge = Form.create()(CPrecharge);

export default withApollo(WCPrecharge);